import axios from "axios";

interface GetOptionsDetails {
    record_id?: string;
    MSD?: any[];
    Transfer?: any[];
}

type GetDetailsResponse = {
    data?: GetOptionsDetails;
    error?: string;
} | null;

    export const getDetails = async (): Promise<GetDetailsResponse> => {
        const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/getDetails`;
        try {
            const response = await axios.post(
                apiUrl, null,
                {
                    headers: {
                        Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
                        "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY
                    },
                }
            );
             return response; // Return the response if successful
        } catch (err) {
            if (axios.isAxiosError(err) && err?.response) {
                return { error: err?.response?.data?.message || "An error occurred" };
            }
                return { error: "An unexpected error occurred" };
        }
    };
